import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../components/pages/home/Index.vue";
import About from "../components/pages/About.vue";
import ProductsList from "../components/pages/products/List.vue";
import ProductsItem from "../components/pages/products/Item.vue";
import Contact from "../components/pages/Contact.vue";
import WorkUs from "../components/pages/WorkUs.vue";
import FormSuccess from "../components/pages/fallback/FormSuccess.vue";
import Error404 from "../components/pages/fallback/Error404.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/quem-somos",
    name: "Quem Somos",
    component: About,
  },
  {
    path: "/produtos",
    name: "Produtos",
    component: ProductsList,
  },
  {
    path: "/produtos/:category",
    name: "Produtos",
    component: ProductsList,
  },
  {
    path: "/produtos/:category/:item",
    name: "Produto",
    component: ProductsItem,
  },
  {
    path: "/fale-conosco",
    name: "Fale Conosco",
    component: Contact,
  },
  {
    path: "/fale-conosco/obrigado",
    name: "Obrigado!",
    meta: {
      text: "Agradecemos seu contato, responderemos em breve.",
      to: "/fale-conosco",
    },
    component: FormSuccess,
  },
  {
    path: "/trabalhe-conosco",
    name: "Trabalhe Conosco",
    component: WorkUs,
  },
  {
    path: "/trabalhe-conosco/obrigado",
    name: "Obrigado!",
    meta: {
      text: "Agradecemos seu interesse em trabalhar conosco, responderemos em breve.",
      to: "/trabalhe-conosco",
    },
    component: FormSuccess,
  },
  {
    name: "Erro 404",
    path: "/erro404",
    component: Error404,
  },
  {
    path: "*",
    beforeEnter: (to, from, next) => {
      next("/erro404");
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

export default router;
